<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_5"><span class="txbfit">To I. L. M.</span></a></p><a id="page_5">
<p class="deda"><span class="txbfit">Govindam adi purusham tam aham bhajami</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2c254928